module.exports = __webpack_public_path__ + "img/droplets-02.d7cb531f.svg";